import styled from 'styled-components';

const InfoBox = styled.div`
  background-color: ${(props) => props.theme.colors.red};
  border-radius: 6px 0 6px 6px;
  padding: 8px;
  font-size: 13px;
  color: ${(props) => props.theme.colors.black};
  text-align: center;

  button {
    margin-top: 5px;
    display: block;
    width: 100%;
    text-align: center;
  }

  button:hover {
    color: ${(props) => props.theme.colors.orange};
    font-weight: bold;
  }
`;

export default { InfoBox };
